import {GET_GROUPS_SUCCESS} from "../actions/types";

const initialState = {

};

const groupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GROUPS_SUCCESS:
            return {...state, groups: action.payload};
        default:
            return state;
    }
};

export default groupsReducer;
